import { Box, Stack } from 'styled-system/jsx';
import { ReactNode } from 'react';

const SignatureWrapper = ({ children }: { children: ReactNode }) => {
  return (
    <Stack
      margin="auto"
      width="100%"
      pb="100%"
      boxShadow={'2px 2px 2px 2px #BFBFBF1A '}
      borderRadius="8px"
      backgroundColor="#FFFFFF"
      position="relative"
      gap="0"
    >
      <Box
        position="absolute"
        top={0}
        bottom={0}
        left={0}
        right={0}
        w="100%"
        height="100%"
      >
        {children}
      </Box>
    </Stack>
  );
};
export default SignatureWrapper;
